<h1 ev-dialog-title data-testid="set-battery-title">{{ vehicleName || languageService.languageJSON.SliderSidebar_BatteryLevel }}</h1>

<div ev-dialog-content data-testid="set-battery-container">
  <div class="battery-content">
    <app-vehicle-property
      data-testid="set-battery-level-slider"
      [label]="languageService.languageJSON.SliderSidebar_BatteryLevel"
      [displayValue]="(batteryLevel | number:'1.0-0') + ' %'"
      [min]="1" [max]="100" [digit]="0" [step]="90"
      [altString]="'battery level'" [value]="batteryLevel" [stepButtons]="true"
      (valueDragEvent)="batteryLevel = $event"
      (valueChangeEvent)="batteryLevel = $event">
    </app-vehicle-property>

    <p class="battery-description">{{ languageService.languageJSON.NavigationSetBatteryDialog_Description }}</p>
  </div>
</div>

<div ev-dialog-actions>
  <button class="ev-button primary" mat-button data-testid="set-battery-ok-btn" (click)="setBatteryClick()">{{ languageService.languageJSON.Global_Ok }}</button>
</div>
